import { FC } from 'react'

import { Cluster, Grid, Skeleton, Stack, Table } from '@forto-dev/phoenix-ui-core'
import { Layout } from '@forto-dev/phoenix-ui-core/ship'

import { Back } from '@/fragments/back'
import { Footer } from '@/fragments/footer'
import { Header } from '@/fragments/header'
import { WidgetSkeleton } from '@/fragments/widgetSkeleton'
import { useLocalisation } from '@/utils/localisation'

import { ShipmentDetailTitleSkeleton } from '../details/detailsSkeleton'

const ShipmentPriceBreakdownMainSkeleton: FC = () => {
  const { translate } = useLocalisation()
  return (
    <Stack gap={24}>
      {Array.from({ length: 2 }).map((_, index) => (
        <Stack gap={16} key={index}>
          <Grid col={6}>
            <Skeleton variant="badge" fullWidth />
          </Grid>
          <Table
            columns={[
              {
                id: 'lineItem',
                header: translate('details.breakdown.table.lineItem'),
                cell: () => <Skeleton variant="content" />,
                accessorKey: '',
              },
              {
                id: 'originalPrice',
                header: translate('details.breakdown.table.originalPrice'),
                cell: () => <Skeleton variant="content" />,
                accessorKey: '',
              },
              {
                id: 'invoiceNetPrice',
                header: translate('details.breakdown.table.invoiceNetPrice'),
                cell: () => <Skeleton variant="content" />,
                accessorKey: '',
                footer: () => {
                  return (
                    <Stack gap={12}>
                      <Cluster />
                      <Grid col={4}>
                        <Skeleton variant="badge" fullWidth />
                      </Grid>
                      <Cluster />
                    </Stack>
                  )
                },
              },
            ]}
            data={[{}]}
            footless
          />
        </Stack>
      ))}
    </Stack>
  )
}

export const ShipmentPriceBreakdownSkeleton: FC = () => {
  return (
    <Layout
      header={<Header />}
      title={<ShipmentDetailTitleSkeleton />}
      hideTitleBackgroundImage
      sidebar={<WidgetSkeleton count={5} />}
      navigation={<Back to="/" />}
      main={<ShipmentPriceBreakdownMainSkeleton />}
      footer={<Footer />}
    />
  )
}
